import React from 'react';
import {connect} from 'react-redux';
import './styles.less';

export const mapStateToProps = ({modules: {mlpSeoText}}) => ({mlpSeoText});

export function SeoSectionComponent({mlpSeoText}) {
    return (
        mlpSeoText && (
            <section
                className="SeoSection section section--centered"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{__html: mlpSeoText}}
            />
        )
    );
}

export const SeoSection = connect(mapStateToProps)(SeoSectionComponent);

SeoSection.displayName = 'SeoSection';

export default SeoSection;
